<template>
  <div class="inputCon">
    <label class="labelStyle">
      <span v-if="required != undefined">*</span>{{label}}：
    </label>
    <input
      :class="['inputStyle', ifRequired || showText != '' ? 'required' : '', type == 'code' ? 'codeInput' : '', readonly == true ? 'disable' : '']"
      value=""
      v-model="val"
      :placeholder="placeholder"
      :type="type"
      :maxlength="maxlength"
      @blur="blur"
      @focus="focus"
      :disabled="readonly == true"
      autocomplete="off"
    >

    <div v-if="type == 'code'" :class="['sendBtn', sended ? 'disable' : '']" @click="sendBtnClick">
      {{sendBtnText}}
    </div>

    <div v-if="showText != ''" class="showText">
      {{showText}}
    </div>

  </div>
</template>

<script>

  export default {
    name: 'HintInput',
    data () {
      return {
        ifRequired: false,
        // 提醒显示文字, 默认为0 后期赋空只为改变
        showText: 0,
        val: '',
        sended: false,
        sendBtnText: '发送验证码',
        // 默认倒计时时间
        defaultTimer: 40,
        verifyRes: false
      }
    },
    props: ['name', 'label', 'value', 'placeholder', 'required', 'verify', 'type', 'result', 'maxTimer', 'cusVerify', 'readonly', 'maxlength'],
    methods: {
      blur (data) {
        var ifRequired = typeof this.required !== 'undefined'
          // , thisDom = data.target
          , nameShow = '请输入正确的中文姓名'
          , telShow = '请输入正确的手机号码'
          , pwd0Show = '请输入4-16位密码，必须包含数字、字母，不能为空格'
          , pwd1Show = '密码不一致，请重新输入'

        // 先重置下
        this.showText = 0

        // 必填项
        if (ifRequired && this.val.length == 0) {
          this.ifRequired = true
          this.showText = this.label + '不能为空'
          return
        } else if (ifRequired) {
          this.ifRequired = false
          this.showText = ''
        }

        // 验证规则
        switch (this.verify) {
          case 'name': // 姓名
            if (this.$utils.testName(this.val)) {
              this.showText = ''
              // this.result = true
            } else {
              this.showText = nameShow
              // this.result = false
              return
            }
            break
          case 'tel': // 电话
            if (this.$utils.testPhone(this.val)) {
              this.showText = ''
            } else {
              this.showText = telShow
              return
            }
            break
          case 'pwd0': // 密码
            var pwd1 = this.$store.getters.getPwd1
            if (pwd1 != '' && pwd1 != this.val) {
              this.$store.commit('doPwd1Show', pwd1Show)
              console.log(this.$store.state)
            }
            if (this.val.length < 4 || this.val.length > 16 || !this.$utils.testPwd(this.val)) {
              this.showText = pwd0Show
              this.$store.commit('setPwd0', '')
            } else {
              this.showText = ''
              this.$store.commit('setPwd0', this.val)
              return
            }
            break
          case 'pwd1': // 重复密码
            var pwd0 = this.$store.getters.getPwd0
            if (pwd0 == '') {
              this.$store.commit('doPwd0Show', pwd0Show)
              return
            }
            if (this.val != pwd0) {
              this.showText = pwd1Show
              this.$store.commit('setPwd1', '')
              return
            } else {
              this.showText = ''
              this.$store.commit('setPwd1', this.val)
            }
            break
        }

        // 自定义验证回调
        if (typeof this.cusVerify === 'function') {
          // 调用回调
          var that = this
          this.cusVerify({
              showText: this.showText,
              value: this.val
            },
            // 回调组件中的方
            function (showText) {
              that.showText = showText
            })
        }

      },

      focus () {
        // this.showText = ''
      },

      // 发送验证码点击
      sendBtnClick () {
        if (this.sended) {
          return
        }

        // 如果手机号不通过
        // console.log(this.$store.getters.ifPhone)
        // // return
        // if (this.$store.getters.ifPhone == false) {
        //   // this.$emit('sendBtnClick', {
        //   //   timer: timer
        //   // })
        //   return
        // }

        // 发送到父控件 进行异步请求
        this.$emit('sendBtnClick', {
          cb: this.setTimerShow
        })
      }
      // 设置倒计时显示
      , setTimerShow () {
        let that = this
        // 开始倒计时显示
        this.sended = true
        that.sendBtnText = '重新发送(' + that.defaultTimer + ')'
        // 倒计时一分钟
        let timer = setInterval(function () {
          that.defaultTimer--
          that.sendBtnText = '重新发送(' + that.defaultTimer + ')'
          if (that.defaultTimer == 0) {
            that.sended = false
            that.defaultTimer = that.maxTimer || that.defaultTimer
            that.sendBtnText = '重新发送'
            clearInterval(timer)
          }
        }, 1000)
      }
    },
    created () {
      // value值
      this.val = this.value || ''
      // 验证码倒计时
      this.defaultTimer = this.maxTimer || this.defaultTimer

      if (this.verify == 'pwd0') {
        // 设置密码1的提示文字
        this.$store.commit('setPwd0ShowText', this)
      } else if (this.verify == 'pwd1') {
        // 设置密码2的提示文字
        this.$store.commit('setPwd1ShowText', this)
      }
    },
    watch: {
      showText: function (newShowText, oldShowText) {
        this.verifyRes = newShowText == ''

        // 设置验证回调
        this.$emit('verifyCallback', this.name, this.verifyRes ? this.val : '')

        // 如果为联系方式
        // if (this.verify == 'tel') {
        //   this.$store.commit('setIfPhone', this.verifyRes)
        // }
      },
      result: function (newResult) {
        console.log(newResult)
      }
      , val: function (value) {
        // 设置最终value值
        // if (this.name){
        //   this.$emit('update:' + this.name, this.val)
        // }
        this.showText = 0
        this.$emit('update:value', value)
      }
    }
  }
</script>

<style scoped>
  p, div, input {
    overflow: hidden;
    transition: all .3s;
  }

  .inputCon {
    width: auto;
    height: 40px;
    margin-bottom: 20px;
  }

  .labelStyle {
    display: inline-block;
    height: 40px;
    width: 339px;
    line-height: 40px;
    text-align: right;
    font-size: 14px;
    color: #000000;
    letter-spacing: 0;
  }

  .labelStyle span {
    font-size: 14px;
    color: #FF4D4D;
    letter-spacing: 0;
  }

  .inputStyle {
    width: 350px;
    height: 40px;
    padding: 0 14px;
    outline: none;
    box-sizing: border-box;
    background: #FFFFFF;
    border: 1px solid #DCE0E7;
    border-radius: 4px;
    font-size: 14px;
  }

  .inputStyle:hover, .inputStyle:focus {
    border-color: #3bb4f2;
  }

  .required {
    border-color: #FF4D4D;
  }

  .inputStyle:-ms-input-placeholder,
  textarea:-ms-input-placeholder {
    color: #ADADAD;
  }

  .inputStyle::-webkit-input-placeholder,
  textarea::-webkit-input-placeholder {
    color: #ADADAD;
  }

  .showText {
    display: inline-table;
    width: auto;
    height: 24px;
    padding-right: 8px;
    margin-left: 16px;
    line-height: 24px;
    background: #FFF2F2 url("../assets/error.png") no-repeat 7px center;
    border: 1px solid #FFE3E0;
    border-radius: 4px;
    font-size: 13px;
    color: #FF4D4D;
    letter-spacing: 0;
    text-indent: 26px;
  }

  .codeInput {
    width: 232px;
  }

  .sendBtn {
    display: inline-table;
    box-sizing: border-box;
    width: 110px;
    height: 38px;
    line-height: 38px;
    text-align: center;
    margin-left: 8px;
    background: #F1F8FF;
    border: 1px solid #BFD2F3;
    border-radius: 4px;
    font-size: 14px;
    color: #016EEE;
    cursor: pointer;
  }

  .disable {
    cursor: not-allowed;
    background: #F3F3F3;
    border: 1px solid #DCE0E7;
    color: #B6B6B6;
  }
</style>



// WEBPACK FOOTER //
// src/components/HintInput.vue